#import "../fragments/comment-fragment.graphql"

mutation CreateComment($input: CreateCommentInput!) {
    commentCreate(input: $input) {
        comment {
            ...CommentFragment
        }
    }
}
